import { render, staticRenderFns } from "./ModalConfirmacaoValores.vue?vue&type=template&id=d4097324&scoped=true"
import script from "./ModalConfirmacaoValores.vue?vue&type=script&lang=js"
export * from "./ModalConfirmacaoValores.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmacaoValores.vue?vue&type=style&index=0&id=d4097324&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4097324",
  null
  
)

export default component.exports